export default {

    data(){

        return {

            loading     : false,
            items       : [],

            totalRows   : 0,
            perPage     : 25,
            currentPage : 1,
            sortBy      : 'created_at',
            sortDesc    : true,
        }
    },
    computed: {

        sortableFields(){ return this.fields ? this.fields.filter( x => x.sortable ).map( x => x.key ) : []; },
        paginationControls(){

            return `&page=${this.currentPage}&perPage=${this.perPage}`;
        },
        sortControls(){

            let sort = this.sortableFields.includes( this.sortBy ) ? this.sortBy : '';

            return `&sort=${sort}&desc=${this.sortDesc}`;
        },
        firstItem(){ return ( this.currentPage - 1 ) * this.perPage; },
        lastItem(){ return ( this.firstItem + this.perPage <= this.totalRows ? this.firstItem + this.perPage : this.totalRows ); },
        total(){ return this.lastItem - this.firstItem; },
        paginationText(){

            let firstItem = 0;

            if (this.firstItem >= 50) {
                firstItem = this.firstItem + 1;
            } else {
                firstItem = this.firstItem;
            }

            return `Showing ${firstItem} - ${this.lastItem} of ${this.totalRows} records`;
        },
        appliedFilters(){ /* define in component computed properties to override this for component-specific filters that will trigger the watch-reload */ return '?override=me'; },
        unwatchedFilters(){ /* define in component computed properties to override this for component-specific filters that you dont want to trigger the watch-reload, like free-text search */ return ''; },
        combinedFilters(){ return this.appliedFilters + this.unwatchedFilters; }
    },
    methods: {

        loadTable() {

            if( this.loading ) return;

            this.loading = true;
            let form = new Form();

            form.submit( 'get', this.baseUrl + this.combinedFilters + this.paginationControls + this.sortControls )
                .then( ({ data }) => {

                    // console.log( data );
                    this.totalRows = data.total;
                    this.items     = data.results || [];
                })
                .catch( e => {

                    this.totalRows = 0;
                    this.items     = [];
                }).finally( () => this.loading = false );
        },

        exportXls() {

            alerts.addMessage( 'info', 'Please allow the export to finish generating before proceeding with any other action.' );
            window.open( `${this.baseUrl}${this.combinedFilters}&export=1`, '_blank' );
        },
    },
    mounted(){

        this.loadTable();
    },
    watch: {

        paginationControls(){

            this.loadTable();
        },
        sortControls(){

            this.loadTable();
        },
        appliedFilters(){

            this.loadTable();
        }
    }
}